import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterService } from '@omnipas/services/router.service';

@Component({
  selector: 'omnipas-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

  constructor ( public router: RouterService
              ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    return;
  }

}
